import styles from "./styles.module.scss";
import responsiveStyles from "./responsiveStyles.module.scss";
import { Wrapper } from "../reusable";
import { IsMobile } from "../layout";

function NotPart36Banner() {
    return (
        <div className={`${styles.banner} ${responsiveStyles.banner}`}>
            <Wrapper>
                {IsMobile() ? (
                    <h1>
                        Review and Sign the <br />
                        Settlement Agreement Document
                    </h1>
                ) : (
                    <h1> Review and Sign Settlement Agreement Document</h1>
                )}
                <p>Please read and sign your 'Settlement Agreement Document' to conclude your motor finance claim with Sentinel Legal Ltd.</p>
            </Wrapper>
        </div>
    );
}

export default NotPart36Banner;
